webpackJsonp([1],{

/***/ 140:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.default = Main;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _Install = __webpack_require__(141);

var _Install2 = _interopRequireDefault(_Install);

__webpack_require__(242);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function Main() {
	document.title = 'Sendpoll';

	return _react2.default.createElement(_Install2.default, null);
}

/***/ }),

/***/ 141:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.default = Install;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _logo = __webpack_require__(142);

var _logo2 = _interopRequireDefault(_logo);

__webpack_require__(241);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function Install() {
	if (!/iPad|iPhone/.test(navigator.userAgent)) {
		return null;
	}

	return _react2.default.createElement(
		'div',
		{ className: 'install-bar' },
		_react2.default.createElement(
			'div',
			{ className: 'left' },
			_react2.default.createElement('img', { className: 'logo', src: _logo2.default, alt: 'Sendpoll' })
		),
		_react2.default.createElement(
			'div',
			{ className: 'text' },
			_react2.default.createElement(
				'div',
				{ className: 'title' },
				'Sendpoll'
			),
			_react2.default.createElement(
				'div',
				{ className: 'body' },
				'Install to your home screen'
			)
		),
		_react2.default.createElement(
			'div',
			{ className: 'right' },
			_react2.default.createElement(
				'a',
				{ className: 'btn btn-default', href: '#install' },
				'Install'
			)
		)
	);
}

/***/ }),

/***/ 142:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "img/logo-8320f6.svg";

/***/ }),

/***/ 144:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _runtime = __webpack_require__(247);

var _runtime2 = _interopRequireDefault(_runtime);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; } /* global ga Raven */


if (true) {
	_runtime2.default.install({
		onUpdateReady: function onUpdateReady() {
			return _runtime2.default.applyUpdate();
		},
		onUpdated: function onUpdated() {
			return window.location.reload();
		}
	});

	Raven.config({"facebook":"1308684189194545","analytics":"UA-88910082-1","sentry":"https://bc46ef7cef124a6cae92216ca285790a@sentry.io/122103"}.sentry).install();
}

var dimensions = {
	VIEW_MODE: 'dimension1'
};

var metrics = {
	RESPONSE_END_TIME: 'metric1',
	DOM_LOAD_TIME: 'metric2',
	WINDOW_LOAD_TIME: 'metric3'
};

window.ga = window.ga || function () {
	for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
		args[_key] = arguments[_key];
	}

	return (ga.q = ga.q || []).push(args);
};
ga('create', {"facebook":"1308684189194545","analytics":"UA-88910082-1","sentry":"https://bc46ef7cef124a6cae92216ca285790a@sentry.io/122103"}.analytics, 'auto');
ga('set', 'transport', 'beacon');
ga('send', 'pageview');

if (navigator.standalone) {
	ga('set', dimensions.VIEW_MODE, 'Home Screen');
}

var sendNavigationTimingMetrics = function sendNavigationTimingMetrics() {
	// Only track performance in supporting browsers.
	if (!(window.performance && window.performance.timing)) return;

	// If the window hasn't loaded, run this function after the `load` event.
	if (document.readyState !== 'complete') {
		window.addEventListener('load', sendNavigationTimingMetrics);
		return;
	}

	var nt = performance.timing;
	var navStart = nt.navigationStart;

	var responseEnd = Math.round(nt.responseEnd - navStart);
	var domLoaded = Math.round(nt.domContentLoadedEventStart - navStart);
	var windowLoaded = Math.round(nt.loadEventStart - navStart);

	// In some edge cases browsers return very obviously incorrect NT values,
	// e.g. 0, negative, or future times. This validates values before sending.
	var allValuesAreValid = function allValuesAreValid() {
		for (var _len2 = arguments.length, values = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
			values[_key2] = arguments[_key2];
		}

		return values.every(function (value) {
			return value > 0 && value < 1e6;
		});
	};

	if (allValuesAreValid(responseEnd, domLoaded, windowLoaded)) {
		var _ga;

		ga('send', 'event', (_ga = {
			eventCategory: 'Navigation Timing',
			eventAction: 'track',
			nonInteraction: true
		}, _defineProperty(_ga, metrics.RESPONSE_END_TIME, responseEnd), _defineProperty(_ga, metrics.DOM_LOAD_TIME, domLoaded), _defineProperty(_ga, metrics.WINDOW_LOAD_TIME, windowLoaded), _ga));
	}
};

sendNavigationTimingMetrics();

/***/ }),

/***/ 145:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var reduce = Function.bind.call(Function.call, Array.prototype.reduce);
var isEnumerable = Function.bind.call(Function.call, Object.prototype.propertyIsEnumerable);
var concat = Function.bind.call(Function.call, Array.prototype.concat);
var keys = Reflect.ownKeys;

if (!Object.values) {
	Object.values = function values(O) {
		return reduce(keys(O), function (v, k) {
			return concat(v, typeof k === 'string' && isEnumerable(O, k) ? [O[k]] : []);
		}, []);
	};
}

if (!Object.entries) {
	Object.entries = function entries(O) {
		return reduce(keys(O), function (e, k) {
			return concat(e, typeof k === 'string' && isEnumerable(O, k) ? [[k, O[k]]] : []);
		}, []);
	};
}

/***/ }),

/***/ 607:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(608);


/***/ }),

/***/ 608:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__(18);

var _reactDom2 = _interopRequireDefault(_reactDom);

var _reactHotLoader = __webpack_require__(178);

var _Main = __webpack_require__(140);

var _Main2 = _interopRequireDefault(_Main);

__webpack_require__(144);

__webpack_require__(145);

__webpack_require__(248);

__webpack_require__(609);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

if (navigator.standalone) {
	location.replace('/polls');
}

_reactDom2.default.render(_react2.default.createElement(
	_reactHotLoader.AppContainer,
	null,
	_react2.default.createElement(_Main2.default, null)
), document.getElementById('root'));

if (false) {
	module.hot.accept('./components/main/Main', function () {
		// eslint-disable-next-line global-require
		var NewRoot = require('./components/main/Main').default;
		_reactDom2.default.render(_react2.default.createElement(
			_reactHotLoader.AppContainer,
			null,
			_react2.default.createElement(NewRoot, null)
		), document.getElementById('root'));
	});
}

/***/ })

},[607]);


// WEBPACK FOOTER //
// landing-41083ab26793a9088660.js